import { useEffect, useState } from "react";
import ReportMenu from "../../models/reports/report-menu";
import Item from "antd/es/list/Item";
import { Link } from "react-router-dom";
import ReportMenuCategory from "../../models/reports/report-menu-category";
import './report-center.scss';
import Dashboard from "../home/dashboard.page";
import { DailyCounterSaleReport } from "./order and collection/dailycountersale-report";
import { DailyCounterSalesSummaryReport } from "./order and collection/dailycountersalesummary-report";
import MonthlyCounterSaleSummaryReport from "./order and collection/monthlycountersalesummary-report";
import { PrepareIndentReport } from "./indent/prepareindent-report";
import { OldIndentReport } from "./indent/oldindent-report";
import { RouteSummaryReport } from "./dailyreports/routesummary-report";
import { RouteAbstractReport } from "./dailyreports/routeabstract-report";
import { ZoneSummaryReport } from "./dailyreports/zonesummary-report";
import { ZoneAbstractReport } from "./dailyreports/zoneabstract-report";
import { ZoneRoutewiseAbstractReport } from "./dailyreports/zoneroutewiseabstract-report";
import { UnionWiseSummaryReport } from "./dailyreports/unionwisesummary-report";
import { DailyCashCollectionReport } from "./dailyreports/dailycashcollection-report";
import { CitywiseRouteSaleReport } from "./dailyreports/citywiseroutesale-report";
import { MilkAcknowledgmentReport } from "./dailyreports/milkacknowlegement-report";
import { AgentMonthlyReport } from "./monthlyreports/agentmonthlyreport-report";
import { MonthlyInstitutionBillAbstractReport } from "./monthlyreports/monthlyinstitutionbillabstract-report";
import { CommissionReport } from "./monthlyreports/commissionreport-report";
import { SocietyBillReport } from "./monthlyreports/societybill-report";
import { InstitutionBillReport } from "./monthlyreports/institutionbill-report";
import { FermentedMilkJSONReport } from "./monthlyreports/fermentedmilkjson-report";
import { FermentedMilkGSTBillReport } from "./monthlyreports/fermentedmilkgstbill-report";
import { OnlinePaymentLogReport } from "./onlinepayment/onlinepaymentlog-report";
import { AgentTransactionReport } from "./onlinepayment/agenttransaction-report";
import { PaymentReport } from "./onlinepayment/payment-report";
import { WalletLogReport } from "./onlinepayment/walletlog-report";
import PrepareIndentNewReport from "./indent/prepareindentnew-report";
import { UnionWiseEntryCheckListReport } from "./dailyreports/unionwiseentrychecklist-report";
import { CashCollectionReport } from "./dailyreports/cashcollectionchecklist-report";
import MonthWiseComparativeModel from "../../models/masters/monthwisecomparative-model";
import { MonthWiseComparativeReport } from "./analysereport/monthwisecomparative-report";
import DateWiseComparative from "../../models/reports/datewisecomparative-reports";
import { YearWiseComparativeReport } from "./analysereport/yearwisecomparative-report";
import { DateWiseComparativeReport } from "./analysereport/datewisecomparative-report";
import { RouteWiseIndentReport } from "./dailyreports/routewiseindent-report";




export const ReportCenter: React.FC = () => {
  const [reportMenu, setReportMenu] = useState<ReportMenuCategory[]>([]);

  useEffect(() => {
    onLoadMenu();
  }, [reportMenu]);

  const [activePage, setActivePage] = useState<string>("report-center");

  const renderPage = (activepage: string) => {
    switch (activepage) {
      case "/DailyCounterSale":
        return <DailyCounterSaleReport />;
      case "/DailyCounterSaleSummary":
        return <DailyCounterSalesSummaryReport />;
      case "/MonthlyCounterSaleSummary":
        return <MonthlyCounterSaleSummaryReport />;


      case "/PrepareIndent":
        return <PrepareIndentNewReport />;
      case "/OldIndent":
        return <OldIndentReport />;



      case "/RouteSummary":
        return <RouteSummaryReport />;
      case "/RouteAbstract":
        return <RouteAbstractReport />;
      case "/ZoneSummary":
        return <ZoneSummaryReport />;
      case "/ZoneAbstract":
        return <ZoneAbstractReport />;
      case "/ZoneRoutewiseAbstract":
        return <ZoneRoutewiseAbstractReport />;
      case "/UnionWiseEntryCheckList":
        return <UnionWiseEntryCheckListReport />;
      case "/UnionwiseSummary":
        return <UnionWiseSummaryReport />;
      case "/DailyCashCollection":
        return <DailyCashCollectionReport />;
      case "/CitywiseRouteSale":
        return <CitywiseRouteSaleReport />;
      case "/MilkAcknowledgment":
        return <MilkAcknowledgmentReport />;
      case "/RouteWiseIndent":
        return <RouteWiseIndentReport />;


      case "/AgentMonthlyReport":
        return <AgentMonthlyReport />;
      case "/MonthlyInstitutionBillAbstract":
        return <MonthlyInstitutionBillAbstractReport />;
      case "/CommissionReport":
        return <CommissionReport />;
      case "/SocietyBill":
        return <SocietyBillReport />;
      case "/InstitutionBill":
        return <InstitutionBillReport />;
      case "/FermentedMilkJSON":
        return <FermentedMilkJSONReport />;
      case "/FermentedMilkGStBill":
        return <FermentedMilkGSTBillReport />;


      case "/MonthWiseComparative":
        return <MonthWiseComparativeReport />;
      case "/DateWiseComparative":
        return <DateWiseComparativeReport />;
      case "/YearWiseComparative":
        return <YearWiseComparativeReport />;

      case "/OnlinePaymentLogReport":
        return <OnlinePaymentLogReport />;
      case "/AgentTransactionReport":
        return <AgentTransactionReport />;
      case "/PaymentReport":
        return <PaymentReport />;
      case "/WalletLog":
        return <WalletLogReport />;
      case "/OnlinePaymentLogReport":
        return <OnlinePaymentLogReport />;
      case "/AgentTransactionReport":
        return <AgentTransactionReport />;
      case "/PaymentReport":
        return <PaymentReport />;
      case "/WalletLog":
        return <WalletLogReport />;
      case "/CashCollection":
        return <CashCollectionReport />;


      default:
        return null;
    }
  }

  useEffect(() => {
    onLoadMenu();
  }, []);

  const onLoadMenu = () => {

    let reportsList: ReportMenuCategory[] = [{
      categorId: 1,
      categoryName: "Order & Collection Reports",
      reportMenu: [
        { reportId: 1, reportName: "Daily Counter Sale Report", to: "/DailyCounterSale" },
        { reportId: 1, reportName: "Daily Counter Sale Summary", to: "/DailyCounterSaleSummary" },
        { reportId: 1, reportName: "Monthly Counter Sale Summary", to: "/MonthlyCounterSaleSummary" },
        // { reportId: 1, reportName: "Product List" },
        // { reportId: 1, reportName: "Rate Chart" },
        // { reportId: 1, reportName: "Employee List" },
        // { reportId: 1, reportName: "Consumer List" },
      ]
    }];

    // const reportObject: ReportMenuCategory =  {
    //     categorId: 3,
    //     categoryName: "Sales",
    //     reportMenu: [
    //       { reportId: 1, reportName: "Daily Sales" },
    //       { reportId: 1, reportName: "Periodical Sales" },
    //       { reportId: 1, reportName: "Sales Comparision" },
    //       { reportId: 1, reportName: "Routewise Sales" },
    //       { reportId: 1, reportName: "Categorywise Sales" },
    //       { reportId: 1, reportName: "Partywise Sales" },
    //     ]
    // }


    // reportsList.push(reportObject);

    let reportsIndent: ReportMenuCategory = {
      categorId: 2,
      categoryName: "Indent",
      reportMenu: [

        { reportId: 1, reportName: "Prepare Indent", to: "/PrepareIndent" },
        { reportId: 1, reportName: "Old Indent", to: "/OldIndent" },
        // { reportId: 1, reportName: "Gate Pass" },
        // { reportId: 1, reportName: "Delivery Note" },


      ]
    };
    reportsList.push(reportsIndent);

    let reportDaily: ReportMenuCategory = {
      categorId: 3,
      categoryName: "Daily Reports",
      reportMenu: [
        { reportId: 1, reportName: "Route Summary", to: "/RouteSummary" },
        { reportId: 1, reportName: "Route Abstract", to: "/RouteAbstract" },
        { reportId: 1, reportName: "Zone Summary", to: "/ZoneSummary" },
        { reportId: 1, reportName: "Zone Abstract", to: "/ZoneAbstract" },
        { reportId: 1, reportName: "Zone Route Wise Abstract", to: "/ZoneRoutewiseAbstract" },
        { reportId: 1, reportName: "Union Wise Entry Check List", to: "/UnionWiseEntryCheckList" },
        { reportId: 1, reportName: "Union Wise Summary", to: "/UnionwiseSummary" },
        { reportId: 1, reportName: " Daily Cash Collection", to: "/DailyCashCollection" },
        { reportId: 1, reportName: "City Wise Route Sale", to: "/CitywiseRouteSale" },
        { reportId: 1, reportName: "Milk Acknowledgement", to: "/MilkAcknowledgment" },
        { reportId: 1, reportName: "Cash Collection", to: "/CashCollection" },
        { reportId: 1, reportName: "Route Wise Indent", to: "/RouteWiseIndent" },



        //{ reportId: 1, reportName: "Institution Bill" },

      ]
    };
    reportsList.push(reportDaily);



    //   let moneyManagement: ReportMenuCategory={
    //     categorId: 3,
    //     categoryName: "Money Management",
    //     reportMenu: [
    //       { reportId: 1, reportName: " Agent Transaction", to:"/ScheduledReport" },
    //       { reportId: 1, reportName: " Auto Enquiry Log" },
    //       { reportId: 1, reportName: "Bill payment Register" },
    //       { reportId: 1, reportName: "Online Payment Log Excel" },
    //       { reportId: 1, reportName: "Online Payment Log" },
    //       { reportId: 1, reportName: "Payment Report" },
    //       { reportId: 1, reportName: "Wallet Log" },


    //     ]
    // };
    // reportsList.push(moneyManagement);

    let monthlyReport: ReportMenuCategory = {
      categorId: 3,
      categoryName: "Monthly Reports",
      reportMenu: [
        // { reportId: 1, reportName: "Monthly Dairy Summary",to:"/MonthlyDairySummary" },
        { reportId: 1, reportName: "Agent Monthly Report", to: "/AgentMonthlyReport" },
        { reportId: 1, reportName: "Monthly Institution Bill Abstract", to: "/MonthlyInstitutionBillAbstract" },
        { reportId: 1, reportName: "Commission Report", to: "/CommissionReport" },
        { reportId: 1, reportName: "Society Bill", to: "/SocietyBill" },
        { reportId: 1, reportName: "Institution Bill", to: "/InstitutionBill" },
        { reportId: 1, reportName: "Fermented Milk JSON", to: "/FermentedMilkJSON" },
        { reportId: 1, reportName: "Fermented Milk GST Bill", to: "/FermentedMilkGStBill" },

        // { reportId: 1, reportName: "Incentive" },

        // { reportId: 1, reportName: "Institution Bill With GST" },
        // { reportId: 1, reportName: "Monthly Bill" },
        // { reportId: 1, reportName: "Monthly Institution Bill Abstract" },
        // { reportId: 1, reportName: "Report3" },


      ]
    };
    reportsList.push(monthlyReport);
    let order: ReportMenuCategory = {
      categorId: 3,
      categoryName: "Analyse Reports",
      reportMenu: [
        { reportId: 1, reportName: "Date Wise Comparative", to: "/DateWiseComparative" },
        { reportId: 1, reportName: "Month Wise Comparative", to: "/MonthWiseComparative" },
        { reportId: 1, reportName: "Year Wise Comparative", to: "/YearWiseComparative" },

        // { reportId: 1, reportName: "DailyCounter SaleReport Customer" },
        // { reportId: 1, reportName: "DailyCounter Sale Summary"},
        // { reportId: 1, reportName: "MonthlyCounter Sale Summary" },
        // { reportId: 1, reportName: "Order Time Change" },



      ]
    };
    reportsList.push(order);

    let payment: ReportMenuCategory = {
      categorId: 3,
      categoryName: "Online Payment Management",
      reportMenu: [
        { reportId: 1, reportName: "Online Payment Log", to: "/OnlinePaymentLogReport" },
        { reportId: 1, reportName: "Agent Transactions", to: "/AgentTransactionReport" },
        { reportId: 1, reportName: "Payment Report", to: "/PaymentReport" },
        { reportId: 1, reportName: "Wallet Log", to: "/WalletLog" },
        //{ reportId: 1, reportName: "PR3 Carry Over Report" },



      ]
    };
    reportsList.push(payment);

    reportsList.sort((a, b) => a.categorId - b.categorId)

    setReportMenu(reportsList);
    // reportObject = {
    //   categorId: 1,
    //   categoryName: "Masters",
    //   reportMenu: [
    //     { reportId: 1, reportName: "Master Report" },
    //     { reportId: 1, reportName: "Master Report 1" },
    //     { reportId: 1, reportName: "Master Report 3" },
    //   ],
    // };
    // reportsList.push(reportObject);


  };

  return (
    <>
      {activePage === "report-center" ? (
        // Report Center menu
        <div className="m-lg-5 mt-lg-3 m-4 p-4 card border-0 m-3 sw-shadow radius-1">
          <div className="top-sec-align row">
            <center>
              <h4 className="text-normal title-web mb-0 report-title-color">Report Center</h4>
            </center>
          </div>
          <div className="fade_rule mb-5"></div>
          <div>
            {reportMenu.map((item: ReportMenuCategory) => (
              <>
                <div><h4 className="report-title-color">{item.categoryName}</h4></div>
                <hr />
                <div className="row col-12 mb-4">
                  {item.reportMenu.map((reportItem: ReportMenu) => (
                    <div className="col-2 ms-2 me-2 mb-3 d-flex btns">
                      <div
                        style={{ textDecoration: "none", color: "white", cursor: "pointer" }}
                        onClick={() => setActivePage(reportItem.to)}
                      >
                        {reportItem.reportName}
                      </div>
                    </div>
                  ))}
                </div>
              </>
            ))}
          </div>
        </div>
      ) : (
        // Show selected report with a back button
        <div className="m-4">
          {renderPage(activePage)}
          <button className="btn-primary btn search-btn mt-4"

            onClick={() => setActivePage("report-center")}>
            ← Back to Report Center
          </button>
        </div>
      )}
    </>
  );


};
export default ReportCenter;
